import { render } from "./Sv016.vue?vue&type=template&id=22d3309a&scoped=true"
import script from "./Sv016.vue?vue&type=script&lang=js"
export * from "./Sv016.vue?vue&type=script&lang=js"

import "./Sv016.vue?vue&type=style&index=0&id=22d3309a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d3309a"]])

export default __exports__